import React from "react"
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

export default function SortedAscendingIcon() {
  return <ArrowDropUpIcon className="icon" />;
}
